import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const DialogWrapper = ({
  title,
  accept,
  cancel,
  children
}) => {
 
  return (
    <S.Container onClick={cancel}>
      <S.Wrapper onClick={(event) => event.stopPropagation()}>
        <S.TitleBar>
          <S.Close onClick={cancel}>×</S.Close>
        </S.TitleBar>
        <h4>{title}</h4>
        <S.Content>
            {children}
          <S.Buttons>
            <button onClick={accept}>
              Aceptar
            </button>
            <button onClick={cancel}>
              Cancelar
            </button>
          </S.Buttons>
        </S.Content>
      </S.Wrapper>
    </S.Container>
  );
};

DialogWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  accept: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
